module.exports = __webpack_public_path__ + "static/media/request-leave.67b6eb34.svg";